(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-mobile-series-nav]').forEach((nav) => {
      if (nav.dataset.seriesNavInitialized === 'true') return;
      nav.dataset.seriesNavInitialized = 'true';
      const scroll = nav.querySelector('[data-series-nav-scroll]');
      const prev = nav.querySelector('[data-series-nav-prev]');
      const next = nav.querySelector('[data-series-nav-next]');
      if (!scroll || !prev || !next) return;
      const updateArrows = () => {
        const maximum = Math.max(0, scroll.scrollWidth - scroll.clientWidth);
        prev.disabled = maximum < 2 || scroll.scrollLeft < 2;
        next.disabled = maximum < 2 || scroll.scrollLeft > maximum - 2;
      };
      prev.addEventListener('click', () => scroll.scrollBy({left:-scroll.clientWidth * .75,behavior:'smooth'}));
      next.addEventListener('click', () => scroll.scrollBy({left:scroll.clientWidth * .75,behavior:'smooth'}));
      scroll.addEventListener('scroll', updateArrows, {passive:true});
      const selected = nav.querySelector('[aria-current="page"]');
      if (selected) {
        requestAnimationFrame(() => {
          const container = scroll.getBoundingClientRect();
          const item = selected.getBoundingClientRect();
          scroll.scrollLeft += item.left - container.left - (container.width - item.width) / 2;
          updateArrows();
        });
      }
      if (typeof ResizeObserver !== 'undefined') new ResizeObserver(updateArrows).observe(scroll);
      updateArrows();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();